<section class="image-container line-spacing"
  [ngStyle]="{'background-image': 'url(' + basePath + '/assets/img/inicio/inicio-1.jpg)'}">

  <div class="container" style="padding: 0;">
    <div class="board">
      <button type="button" style="z-index:100; float: right;" class="btn btn-dark" (click)="showExitAlert()"
        [attr.aria-label]="'texto_735' | translate">X</button>

      <!-- Breadcrumbs -->
      <div class="breadcrum-div">
        <nav aria-label="breadcrumb" class="nav">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a (click)="showExitAlert()" [innerHTML]="'texto_1' | translate | safe:'html'"></a></li>
            <li class="breadcrumb-item active" aria-current="page" [innerHTML]="'texto_717' | translate | safe:'html'">
            </li>
          </ol>
        </nav>
      </div>
      <!-- End Breadcrumbs -->

      <!-- Navigation Area (Circular Tabs) -->
      <msw-navbar></msw-navbar>
      <!-- End Navigation Area (Circular Tabs) -->

      <!-- Content Area -->
      <div class="tab-content">

        <!-- Title -->
        <div class="text-center mb-4">
          <h2 _ngcontent-pnl-c368 class="head text-center">{{title | translate }}</h2>
        </div>

        <form [formGroup]="passwordForm" style="margin-left: 25px; margin-right: 25px;">
          <!-- Texts 768 -->
          <div class="row justify-content-center">
            <div class="col-md-6">
              <div style="text-align: right;">
                <span style="font-size: 0.75rem; display:block; line-height: 1.5; text-align:justify"
                  [innerHTML]="'texto_768' | translate | safe:'html'">
                </span>
              </div>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-6 mx-auto">
              <div class="form-group">
                <label class="control-label" for="passwordComplaint"
                  style="display: block; text-align: left; margin-bottom: 5px;">
                  {{ 'texto_387' | translate }}
                </label>
                <div style="position: relative;">
                  <input formControlName="passwordComplaint" [type]="passwordVisible ? 'text' : 'password'"
                    class="form-control" id="passwordComplaint" placeholder="{{ 'texto_387' | translate }}">
                  <i class="fa" [ngClass]="{'fa-eye': !passwordVisible, 'fa-eye-slash': passwordVisible}"
                    (click)="togglePasswordVisibility()"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                  <mdb-success
                    style="position: absolute; right: 0; top: 100%; margin-top: 5px; font-size: 0.7rem !important;"
                    *ngIf="passwordForm.get('passwordComplaint')?.valid && passwordForm.get('passwordComplaint')?.touched">
                    {{ 'texto_62' | translate }}
                  </mdb-success>
                  <mdb-error
                    style="position: absolute; right: 0; top: 100%; margin-top: 5px; font-size: 0.7rem !important;"
                    *ngIf="passwordForm.get('passwordComplaint')?.invalid && (passwordForm.get('passwordComplaint')?.dirty || passwordForm.get('passwordComplaint')?.touched)">
                    {{ 'texto_61' | translate }}
                  </mdb-error>
                </div>
                <!-- Details password -->
                <div class="d-flex justify-content-center"
                  *ngIf="passwordForm.get('passwordComplaint')?.invalid && (passwordForm.get('passwordComplaint')?.dirty || passwordForm.get('passwordComplaint')?.touched)">
                  <div class="card mt-3 text-center">
                    <div class="card-body">
                      <ul class="password-criteria list-unstyled">
                        <li [ngClass]="{'valid': hasUpperCase, 'invalid': !hasUpperCase}">
                          <i class="fa"
                            [ngClass]="{'fa-check-circle': hasUpperCase, 'fa-times-circle': !hasUpperCase}"></i>
                          {{ 'texto_791' | translate }}
                        </li>
                        <li [ngClass]="{'valid': hasLowerCase, 'invalid': !hasLowerCase}">
                          <i class="fa"
                            [ngClass]="{'fa-check-circle': hasLowerCase, 'fa-times-circle': !hasLowerCase}"></i>
                          {{ 'texto_792' | translate }}
                        </li>
                        <li [ngClass]="{'valid': hasNumber, 'invalid': !hasNumber}">
                          <i class="fa" [ngClass]="{'fa-check-circle': hasNumber, 'fa-times-circle': !hasNumber}"></i>
                          {{ 'texto_793' | translate }}
                        </li>
                        <li [ngClass]="{'valid': hasSpecialChar, 'invalid': !hasSpecialChar}">
                          <i class="fa"
                            [ngClass]="{'fa-check-circle': hasSpecialChar, 'fa-times-circle': !hasSpecialChar}"></i>
                          {{ 'texto_794' | translate }}
                        </li>
                        <li [ngClass]="{'valid': hasMinLength, 'invalid': !hasMinLength}">
                          <i class="fa"
                            [ngClass]="{'fa-check-circle': hasMinLength, 'fa-times-circle': !hasMinLength}"></i>
                          {{ 'texto_795' | translate }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- End Details password -->
              </div>
            </div>
          </div>

          <!-- Repeated password input -->
          <div class="row justify-content-center">
            <div class="col-md-6 mx-auto">
              <div class="form-group">
                <label class="control-label" for="repeatedPasswordComplaint"
                  style="display: block; text-align: left; margin-bottom: 5px;">
                  {{ 'texto_770' | translate }}
                </label>
                <div style="position: relative;">
                  <input formControlName="repeatedPasswordComplaint"
                    [type]="repeatedPasswordVisible ? 'text' : 'password'" class="form-control"
                    id="repeatedPasswordComplaint" placeholder="{{ 'texto_770' | translate }}">
                  <i class="fa"
                    [ngClass]="{'fa-eye': !repeatedPasswordVisible, 'fa-eye-slash': repeatedPasswordVisible}"
                    (click)="toggleRepeatedPasswordVisibility()"
                    style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer;"></i>
                  <mdb-success
                    style="position: absolute; right: 0; top: 100%; margin-top: 5px; font-size: 0.7rem !important;"
                    *ngIf="passwordForm.get('repeatedPasswordComplaint')?.valid && passwordForm.get('repeatedPasswordComplaint')?.touched && passwordForm.get('repeatedPasswordComplaint')?.value === passwordForm.get('passwordComplaint')?.value">
                    {{ 'texto_62' | translate }}
                  </mdb-success>
                  <mdb-error
                    style="position: absolute; right: 0; top: 100%; margin-top: 5px; font-size: 0.7rem !important;"
                    *ngIf="passwordForm.get('repeatedPasswordComplaint')?.dirty && passwordForm.get('repeatedPasswordComplaint')?.value && passwordForm.get('repeatedPasswordComplaint')?.value !== passwordForm.get('passwordComplaint')?.value">
                    {{ 'texto_61' | translate }}
                  </mdb-error>
                </div>
                <!-- Password Details -->
                <div class="d-flex justify-content-center"
                  *ngIf="passwordForm.get('repeatedPasswordComplaint')?.dirty && passwordForm.get('repeatedPasswordComplaint')?.value && passwordForm.get('repeatedPasswordComplaint')?.value !== passwordForm.get('passwordComplaint')?.value">
                  <div class="card mt-3 text-center">
                    <div class="card-body">
                      <ul class="password-criteria list-unstyled">
                        <li class="invalid">
                          <i class="fa fa-times-circle"></i>
                          {{ 'texto_223' | translate }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Email to recover password -->
          <div *ngIf="!email; else emailIsPresent" class="row justify-content-center">
            <div class="col-md-6 mx-auto">
              <span style="font-size: 0.75rem; display:block; line-height: 1.5; text-align:justify"
                [innerHTML]="'texto_769' | translate | safe:'html'">
              </span>
              <div class="form-group">
                <label class="control-label" for="email" style="display: block; text-align: left; margin-bottom: 5px;">
                  {{ 'texto_82' | translate }}
                </label>
                <div style="position: relative;">
                  <input formControlName="email" class="form-control" id="email"
                    placeholder="{{ 'texto_82' | translate }}">
                  <mdb-error id="email-error" role="alert"
                    *ngIf="passwordForm.get('email')?.invalid && (passwordForm.get('email')?.dirty || passwordForm.get('email')?.touched)"
                    style="position: absolute; right: 0; top: 100%; font-size: 0.75rem; color: red;">
                    {{ 'texto_61' | translate }}
                  </mdb-error>
                  <mdb-success
                    style="position: absolute; right: 0; top: 100%; margin-top: 5px; font-size: 0.7rem !important;"
                    *ngIf="passwordForm.get('email')?.valid && passwordForm.get('email')?.value">
                    {{ 'texto_62' | translate }}
                  </mdb-success>
                </div>
              </div>
            </div>
          </div>
          <ng-template #emailIsPresent>
            <div class="row justify-content-center">
              <div class="col-md-6 mx-auto">
                <span style="font-size: 0.75rem; display:block; line-height: 1.5; text-align:justify"
                  [innerHTML]="'texto_785' | translate | safe:'html'"></span>
              </div>
            </div>
          </ng-template>

          <!-- Save Button -->
          <div class="text-center mt-4">
            <button
              [disabled]="!passwordForm.valid && passwordForm.get('repeatedPasswordComplaint')?.value !== passwordForm.get('passwordComplaint')?.value"
              (click)="crearDenuncia(passwordForm)" mdbBtn rounded="true" class="btn-next" mdbWavesEffect>

              <span>{{ 'texto_717' | translate }}</span>
            </button>
          </div>
          <input type="hidden" id="finaliced" name="finaliced" value="">
        </form>

        <!-- Exit confirmation modal -->
        <div class="modal-backdrop-custom" *ngIf="showModal">
          <div class="modal-custom position-relative">

            <button type="button" class="btn-close-modal" [attr.aria-label]="'texto_735' | translate" (click)="showModal = false">
              ×
            </button>

            <h5 class="modal-title" [innerHTML]="'texto_951' | translate | safe:'html'"></h5>
            <p class="modal-text">
              {{ 'texto_952' | translate }}
              <b>{{ 'texto_717' | translate }}</b>
            </p>

            <div class="modal-actions">
              <button (click)="hide()" mdbBtn rounded="true" class="btn-back" mdbWavesEffect>
                <span>{{ 'texto_953' | translate }}</span>
              </button>
              <button (click)="crearDenuncia(passwordForm)" mdbBtn rounded="true" class="btn-next" mdbWavesEffect>
                <span>{{ 'texto_717' | translate }}</span>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="isLoading" class="loading-overlay">
          <div class="spinner"></div>
          <p>{{ 'texto_885' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</section>